<template>
  <main class="card" role="main">
    <h1>Zawartość</h1>
    <div class="meta">Pobieranie /api automatyczne po załadowaniu strony</div>
    <pre :class="{ error: isError }">{{ output }}</pre>

          <router-link :to="{ name: 'example' }">Example</router-link>
  </main>
</template>

<script>
export default {
  name: "HomeComponent",
  data() {
    return {
      output: "Ładowanie…",
      isError: false
    };
  },
  mounted() {
    this.fetchApi();
  },
  methods: {
    async fetchApi() {
      try {
        let slug = window.location.hostname.split('.')[0];

        if (window.location.hostname === 'order.itars.pl') {
          slug = '';
        }

        const resp = await fetch(`/api/venue/${slug}`, { method: 'GET', cache: 'no-store' });
        const contentType = resp.headers.get('content-type') || '';

        if (!resp.ok) {
          this.output = `Błąd: ${resp.status} ${resp.statusText}`;
          this.isError = true;
          return;
        }

        if (contentType.includes('application/json')) {
          const json = await resp.json();
          this.output = JSON.stringify(json, null, 2);
        } else {
          const text = await resp.text();
          this.output = text;
        }
      } catch (err) {
        this.output = `Błąd połączenia: ${err.message}`;
        this.isError = true;
      }
    }
  }
};
</script>

<style scoped>
:root {
  font-family: system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial;
}
body {
  margin: 0;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f6f7fb;
}
.card {
  width: min(960px, 96%);
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 6px 20px rgba(20, 30, 60, 0.08);
  background: #fff;
}
h1 {
  margin: 0 0 12px;
  font-size: 18px;
}
.meta {
  color: #666;
  font-size: 13px;
  margin-bottom: 12px;
}
pre {
  white-space: pre-wrap;
  word-break: break-word;
  background: #0b0b0b;
  color: #f8f8f2;
  padding: 12px;
  border-radius: 8px;
  max-height: 60vh;
  overflow: auto;
}
.error {
  color: #c62828;
  font-weight: 600;
}
</style>
